import React from 'react';
const context = React.createContext({
    leftSidebarPlaceholderRef: React.createRef(),
    rightSidebarPlaceholderRef: React.createRef(),
});
export const { Provider, Consumer } = context;
export default context;
